import { ErrorHandler, Injectable, inject } from '@angular/core';
import { ErrorReportingService } from '../_services/error-reporting.service';

/**
 * Global Angular ErrorHandler for non-HTTP failures (templates, sync throws, etc.).
 * HttpErrorResponse is skipped inside ErrorReportingService because TrackJsHttpInterceptor
 * already reported it; we still console.error for local debugging.
 */
@Injectable()
export class TrackJsErrorHandler implements ErrorHandler {
  private readonly errorReporting = inject(ErrorReportingService);

  public handleError(error: unknown): void {
    if (this.errorReporting.isEnabled()) {
      this.errorReporting.report(error, { source: 'AngularErrorHandler' });
    }

    console.error(error);
  }
}
